export const Step = {
    SELECT_COMPONENT: "SELECT_COMPONENT",
    DOCUMENT_CAPTURE: "DOCUMENT_CAPTURE",
    FACE_CAPTURE: "FACE_CAPTURE",
    MAGNIFEYE_LIVENESS: "MAGNIFEYE_LIVENESS",
};
